module.exports = __webpack_public_path__ + "7971fbed986f3e7fc0eadff512e5a65a.jpg";